import {stringTool} from '../../../util/string-tool.js';

export default class AddWorkDayController {
  /** @ngInject */
  constructor(
    $log, $mdDialog, $mdToast,
    moment,
    SchoolCommonRoomService,
    EmployeeService
  ) {
    this.$log = $log;
    this.$mdDialog = $mdDialog;
    this.$mdToast = $mdToast;
    this.moment = moment;
    this.SchoolCommonRoomService = SchoolCommonRoomService;
    this.EmployeeService = EmployeeService;
    this.StringTool = stringTool;
    this.mySchoolCommonRoomId = 0;
    this.employees = [];
    this.workDay = {};

    this.date = new Date();
    this.mySchoolCommonRoomId = this.SchoolCommonRoomService.getMySchoolCommonRoom().id;
    this.EmployeeService.getSchoolCommonRoomEmployees(this.mySchoolCommonRoomId).then(result => {
      result.map(employee => {
        employee.firstNameValue = employee.firstName.toLowerCase();
        employee.firstNameValue = this.StringTool.escapePolishCharacters(employee.firstNameValue);
        employee.lastNameValue = employee.lastName.toLowerCase();
        employee.lastNameValue = this.StringTool.escapePolishCharacters(employee.lastNameValue);
        return employee;
      });
      this.employees = result;
    });
  }

  querySearch(query) {
    return query ? this.employees.filter(this.createFilterFor(query)) : this.employees;
  }

  createFilterFor(query) {
    let result = true;
    const lowercaseQuery = query.toLowerCase();
    return employee => {
      if (employee.lastNameValue.search(lowercaseQuery) === 0) {
        result = (employee.lastNameValue.search(lowercaseQuery) === 0);
      } else {
        result = (employee.firstNameValue.search(lowercaseQuery) === 0);
      }

      return result;
    };
  }

  cancel() {
    this.$mdDialog.cancel();
  }

  save(form) {
    if (form.$invalid) {
      return false;
    }

    this.workDay.date = this.moment(this.date).format('YYYY-MM-DD');
    this.workDay.startTime = this.startTime;
    this.workDay.endTime = this.endTime;
    this.EmployeeService.addWorkDay(this.workDay.employee.id, this.workDay)
      .then(() => {
        this.$mdDialog.hide();
        this.$mdToast.show(
          this.$mdToast.simple()
            .textContent('Pomyślnie dodano wpis')
            .position('bottom right')
            .hideDelay(3000)
        );
      }).catch(error => {
        this.$mdDialog.show(
          this.$mdDialog.extendError({
            locals: {error}
          })
        );
      });
  }
}
